import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./bg-logo.png";

const DesktopHeader = () => {
  const [activeMenu, setActiveMenu] = useState(null);

  return (
    <header className="desktop-header">
      <div className="logo">
        <img src={Logo} alt="BridgingSkilled Logo" />
      </div>

      <nav className="menu">
        <ul>
          <li><Link to="/" className="link">Home</Link></li>
          <li><Link to="/about-us" className="link">About Us</Link></li>

          <li
            className="dropdown"
            onMouseEnter={() => setActiveMenu("courses")}
            onMouseLeave={() => setActiveMenu(null)}
          >
            Courses
            {activeMenu === "courses" && (
              <div className="mega-menu">
                <div>
                  <h4>Web Development</h4>
                  <Link to="/mern-stack">MERN Stack</Link>
                  <Link to="/mean-stack">MEAN Stack</Link>
                  <Link to="/php-stack">PHP & MySQL</Link>
                  <Link to="/react">React.js</Link>
                  <Link to="/node">Node.js</Link>
                  <Link to="/angular">Angular</Link>
                </div>
                <div>
                  <h4>Programmings</h4>
                  <a href="#">Python Fullstack</a>
                  <a href="#">Java Fullstack</a>
                </div>
                <div>
                  <h4>Cadd Designs</h4>
                  <a href="#">Autocad</a>
                  <a href="#">Catia</a>
                  <a href="#">Solid Works</a>
                </div>
              </div>
            )}
          </li>

          <li
            className="dropdown"
            onMouseEnter={() => setActiveMenu("trainings")}
            onMouseLeave={() => setActiveMenu(null)}
          >
            Trainings
            {activeMenu === "trainings" && (
              <div className="mega-menu">
                <div>
                  <h4>Corporate Training</h4>
                  <a href="#">IT Companies</a>
                  <a href="#">Mechanical Firms</a>
                  <a href="#">Design Industries</a>
                </div>
                <div>
                  <h4>Industrial Training</h4>
                  <a href="#">Students</a>
                  <a href="#">Internships</a>
                  <a href="#">Workshops</a>
                </div>
              </div>
            )}
          </li>

          <li><Link to="/contact-us" className="link">Contact Us</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default DesktopHeader;
